import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const WebhooksPage = () => import('@/modules/webhooks/pages/WebhookList/index.vue');
const WebhookFormPage = () => import('@/modules/webhooks/pages/WebhookForm/index.vue');

export const webhooksRoutes: Array<RouteRecordRaw> = [
  {
    path: '/webhooks',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'webhooks',
        component: WebhooksPage,
        meta: {
          requiresAuth: true,
          title: 'Webhooks',
          flag: 'feature_webhooks',
        },
      },
    ],
  },
  {
    path: '/webhooks/create',
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'webhooks-form-create',
        component: WebhookFormPage,
        meta: {
          requiresAuth: true,
          flag: 'feature_webhooks',
        },
      },
    ],
  },
  {
    path: '/webhooks/edit/:id',
    name: 'webhooks-edit',
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'webhooks-form-edit',
        component: WebhookFormPage,
        meta: {
          requiresAuth: true,
          flag: 'feature_webhooks',
        },
      },
    ],
  },
];
